export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-first-aid-77921ba7f24d2fcecb78b1beb8b3d6f0.svg";